var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrianglebg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 57,
    viewBox: "0 0 135 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.008 0.945312H0.0078125L135.008 56.7404V0.945312Z",
    fill: "#A7C7EA",
    fillOpacity: 0.36
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135.008 0.945312H42.0078L135.008 56.7404V0.945312Z",
    fill: "#EAF1FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrianglebg2);
export default __webpack_public_path__ + "static/media/Trianglebg2.faddf20f1f0efdcc2251526df4e6c265.svg";
export { ForwardRef as ReactComponent };